import React, { useState } from "react"
import {
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Row,
  Col,
} from "reactstrap"
import CreateBooking from "../../common/config/create-store"
import toast from "react-hot-toast"
import moment from "moment"
import Loader from "../../components/Loader/loader"
import useValidation from "../../hooks/useValidation"
import { inComingIncompleteBooking } from "../../common/config/socket.service"

const CustomerVehicleFlightDetails = ({
  siteSubscribeKey,
  singleProductData,
  setTab,
  dateAndTime,
  setIncompleteData,
  setUserEmail,
  setSms,
  setCancellation,
  formData,
  setFormData,
}) => {
  const [loading, setLoading] = useState(false)
  const { validate, errors, setErrors } = useValidation()

  const handleChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
    const ErrorEmpty = { ...errors, [name]: "" }
    setErrors(ErrorEmpty)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    const validationErrors = validate(
      formData,
      "booking_form",
      singleProductData.api_tag
    )
    if (!validationErrors) {
      return
    }
    setLoading(true)
    const user = JSON.parse(localStorage.getItem("user"))
    setUserEmail(formData?.email)
    const createBookingResponse = await CreateBooking({
      key: siteSubscribeKey,
      company_id: singleProductData?.id,
      title: formData?.title,
      first_name: formData?.first_name,
      last_name: formData?.last_name,
      email: formData?.email,
      contact_no: formData?.contact_no,
      departure: moment(
        `${dateAndTime?.dropOffDate} ${dateAndTime?.dropOffTime}`
      ).format("DD-MM-YYYY HH:mm"),
      arrival: moment(
        `${dateAndTime?.pickUpDate} ${dateAndTime?.pickUpTime}`
      ).format("DD-MM-YYYY HH:mm"),
      departure_terminal: formData?.departure_terminal,
      departure_flight_no: formData?.departure_flight_no,
      arrival_terminal: formData?.arrival_terminal,
      arrival_flight_no: formData?.arrival_flight_no,
      no_of_peoples: formData?.no_of_peoples,
      make: formData?.make,
      model: formData?.model,
      color: formData?.color,
      reg_no: formData?.reg_no,
      amount: singleProductData?.price_before_discount,
      discount: singleProductData?.discount,
      discount_code: singleProductData?.discount_code,
      admin_charges: singleProductData?.admin_charges,
      sms_confirmation: formData?.sms_confirmation,
      cancellation_status: formData?.cancellation_status,
      user_id: String(user?.id),
      search_id: singleProductData?.search_id,
      option_id: singleProductData?.option_id,
    })
    if (createBookingResponse?.response_code == 200) {
      setIncompleteData(createBookingResponse?.data)
      inComingIncompleteBooking({
        data: { reference_no: createBookingResponse?.data?.reference_no },
        token: siteSubscribeKey,
      })
      toast.success("incomplete booking created ")
      setLoading(true)
      setTab("payment-section")
    } else {
      toast.error("failed to creating incomplete booking  ")
      setLoading(false)
    }
  }

  const handleBack = () => {
    setTab("qoute")
  }

  return (
    <Container>
      {loading ? (
        <Loader />
      ) : (
        <Form>
          <Row
            className=" p-4 mb-3 "
            style={{
              boxShadow: "0px 3px 5px rgba(68, 68, 65, 0.2)",
              borderRadius: "10px",
              backgroundColor: "#fafafa",
            }}
          >
            <Row>
              <Col md={2}>
                <FormGroup>
                  <Label for="title" style={{ fontSize: "11px" }}>
                    Title
                  </Label>
                  <Input
                    style={{ fontSize: "11px" }}
                    type="select"
                    name="title"
                    id="title"
                    className="form-input"
                    invalid={errors.title}
                    onChange={handleChange}
                    required
                  >
                    <option value="Mr">Mr</option>
                    <option value="Ms">Ms</option>
                    <option value="Mrs">Mrs</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={5}>
                <FormGroup>
                  <Label style={{ fontSize: "11px" }} for="first_name">
                    First Name
                  </Label>
                  <Input
                    type="text"
                    name="first_name"
                    id="first_name"
                    className="form-input"
                    value={formData.first_name}
                    onChange={handleChange}
                    invalid={errors.first_name}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
              <Col md={5}>
                {" "}
                <FormGroup>
                  <Label for="last_name" style={{ fontSize: "11px" }}>
                    Last Name
                  </Label>
                  <Input
                    type="text"
                    name="last_name"
                    id="last_name"
                    className="form-input"
                    value={formData.last_name}
                    onChange={handleChange}
                    invalid={errors.last_name}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                {" "}
                <FormGroup>
                  <Label for="email" style={{ fontSize: "11px" }}>
                    Email
                  </Label>
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    className="form-input"
                    value={formData.email}
                    onChange={handleChange}
                    invalid={errors.email}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                {" "}
                <FormGroup>
                  <Label for="contact_no" style={{ fontSize: "11px" }}>
                    Contact Number
                  </Label>
                  <Input
                    type="text"
                    name="contact_no"
                    id="contact_no"
                    className="form-input"
                    value={formData.contact_no}
                    onChange={handleChange}
                    invalid={errors.contact_no}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Row>

          <Row
            className=" p-4 mb-3 "
            style={{
              boxShadow: "0px 3px 5px rgba(68, 68, 65, 0.2)",
              borderRadius: "10px",
              backgroundColor: "#fafafa",
            }}
          >
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="departure_terminal" style={{ fontSize: "11px" }}>
                    Departure Terminal
                  </Label>
                  <Input
                    type="select"
                    name="departure_terminal"
                    id="departure_terminal"
                    className="form-input"
                    value={formData.departure_terminal}
                    invalid={errors.departure_terminal}
                    onChange={handleChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="">Select Terminal</option>
                    {singleProductData?.terminals?.map(terminal => (
                      <option key={terminal.id} value={terminal.name}>
                        {terminal.name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="arrival_terminal" style={{ fontSize: "11px" }}>
                    Arrival Terminal
                  </Label>
                  <Input
                    type="select"
                    name="arrival_terminal"
                    id="arrival_terminal"
                    className="form-input"
                    invalid={errors.arrival_terminal}
                    value={formData.arrival_terminal}
                    onChange={handleChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="">Select Terminal</option>
                    {singleProductData?.terminals?.map(terminal => (
                      <option key={terminal.id} value={terminal.name}>
                        {terminal.name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="departure_flight_no" style={{ fontSize: "11px" }}>
                    Departure Flight No
                  </Label>
                  <Input
                    type="text"
                    name="departure_flight_no"
                    id="departure_flight_no"
                    className="form-input"
                    value={formData.departure_flight_no}
                    invalid={errors.departure_flight_no}
                    onChange={handleChange}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="arrival_flight_no" style={{ fontSize: "11px" }}>
                    Arrival Flight No
                  </Label>
                  <Input
                    type="text"
                    name="arrival_flight_no"
                    id="arrival_flight_no"
                    className="form-input"
                    value={formData.arrival_flight_no}
                    invalid={errors.arrival_flight_no}
                    onChange={handleChange}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
              {singleProductData?.type == "Park And Ride" && (
                <Col md={4}>
                  <FormGroup>
                    <Label for="no_of_peoples" style={{ fontSize: "11px" }}>
                      Number of People
                    </Label>
                    <Input
                      type="number"
                      name="no_of_peoples"
                      id="no_of_peoples"
                      className="form-input"
                      value={formData.no_of_peoples}
                      invalid={errors.no_of_peoples}
                      onChange={handleChange}
                      style={{ fontSize: "11px" }}
                      min="0"
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>
          </Row>

          <Row
            className=" p-4 mb-3 "
            style={{
              boxShadow: "0px 3px 5px rgba(68, 68, 65, 0.2)",
              borderRadius: "10px",
              backgroundColor: "#fafafa",
            }}
          >
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="make" style={{ fontSize: "11px" }}>
                    Vehicle Make
                  </Label>
                  <Input
                    type="text"
                    name="make"
                    id="make"
                    className="form-input"
                    value={formData.make}
                    invalid={errors.make}
                    onChange={handleChange}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="model" style={{ fontSize: "11px" }}>
                    Vehicle Model
                  </Label>
                  <Input
                    type="text"
                    name="model"
                    id="model"
                    className="form-input"
                    value={formData.model}
                    onChange={handleChange}
                    style={{ fontSize: "11px" }}
                    invalid={errors.model}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="color" style={{ fontSize: "11px" }}>
                    Vehicle Color
                  </Label>
                  <Input
                    type="text"
                    name="color"
                    id="color"
                    className="form-input"
                    value={formData.color}
                    invalid={errors.color}
                    onChange={handleChange}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup>
                  <Label for="reg_no" style={{ fontSize: "11px" }}>
                    Registration Number
                  </Label>
                  <Input
                    type="text"
                    name="reg_no"
                    id="reg_no"
                    className="form-input"
                    value={formData.reg_no}
                    onChange={handleChange}
                    invalid={errors.reg_no}
                    style={{ fontSize: "11px" }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup check>
                  <Label check style={{ fontSize: "14px" }}>
                    <Input
                      type="checkbox"
                      name="sms_confirmation"
                      checked={formData.sms_confirmation}
                      className="border-primary"
                      onChange={e => {
                        const isChecked = e.target.checked
                        setFormData({
                          ...formData,
                          sms_confirmation: isChecked,
                        })
                        setSms(isChecked ? singleProductData?.sms_charges : 0)
                      }}
                      style={{ fontSize: "14px" }}
                    />
                    SMS Confirmation (+{singleProductData?.sms_charges})
                  </Label>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup check>
                  <Label check style={{ fontSize: "14px" }}>
                    <Input
                      type="checkbox"
                      name="cancellation_status"
                      className="border-primary"
                      checked={formData.cancellation_status}
                      onChange={e => {
                        const isChecked = e.target.checked
                        setFormData({
                          ...formData,
                          cancellation_status: isChecked,
                        })
                        setCancellation(
                          isChecked
                            ? singleProductData?.cancellation_charges
                            : 0
                        )
                      }}
                      style={{ fontSize: "14px" }}
                    />
                    Cancellation Cover (+
                    {singleProductData?.cancellation_charges})
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </Row>

          <Row>
            <Col md={6}>
              <Button
                color="secondary"
                size="sm"
                style={{ width: "100px" }}
                onClick={handleBack}
              >
                Back
              </Button>
            </Col>

            <Col md={6}>
              <Button
                type="submit"
                style={{ width: "100px" }}
                color="primary"
                onClick={handleSubmit}
                size="sm"
              >
                Next
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Container>
  )
}

export default CustomerVehicleFlightDetails
